import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { GlobalRole, SiteRole } from 'src/features/auth';
import { selectAuthAccess } from 'src/features/auth/store';
import { RootState } from 'src/store';

import WithRoleAccess from './WithRoleAccess';

interface IProtectedRouteProps {
	children: React.ReactNode;
	allowedGlobalRoles?: GlobalRole[];
	allowedSiteRoles?: SiteRole[];
}

const ProtectedRoute: React.FC<IProtectedRouteProps> = ({
	children,
	allowedGlobalRoles,
	allowedSiteRoles,
}) => {
	const location = useLocation();
	const accessToken = useSelector(selectAuthAccess);
	const userType = useSelector((state: RootState) => state.auth.user_type);

	if (!accessToken || !userType) {
		return <Navigate to='/signin' state={{ from: location }} replace />;
	}

	return (
		<WithRoleAccess
			allowedGlobalRoles={allowedGlobalRoles}
			allowedSiteRoles={allowedSiteRoles}
			rerouteTo='/unauthorized'
		>
			{children}
		</WithRoleAccess>
	);
};

export default ProtectedRoute;
